import { render, staticRenderFns } from "./OcrUserStoreMapping.vue?vue&type=template&id=784166e6&"
import script from "./OcrUserStoreMapping.vue?vue&type=script&lang=js&"
export * from "./OcrUserStoreMapping.vue?vue&type=script&lang=js&"
import style0 from "./OcrUserStoreMapping.vue?vue&type=style&index=0&id=784166e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports